import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';

class NeighborhoodSlides {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('.splide');

    this.dom.page = this.dom.el.querySelector('.splide-page')
    this.dom.current = this.dom.el.querySelector('.splide-page__current')
    this.dom.total = this.dom.el.querySelector('.splide-page__total')

    this.total = null;
    this.rate = null;

    this.slider = null;
    this.option = {
      autoplay: false,
      type: 'fade',
      perPage: 1,
      rewind: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      speed: 2000,
      arrows: true,
      pagination: false,
      gap: `min(${16 / 16}rem, ${16 / 360 * 100}vw)`,
      mediaQuery: 'min',
      breakpoints: {
        768: {
          arrows: true,
        }
      }
    };

    this.init();
  }

  init() {
    this.slider = new Splide(this.dom.slider, this.option);
    // this.dom.progress = this.slider.root.querySelector('.splide-carousel-progress-bar');
    this.slider.on('mounted move', () => {
      this.total  = this.slider.Components.Controller.getEnd() + 1;
      this.rate = Math.min( ( this.slider.index + 1 ) / this.total, 1 );
      this.setPage();
    } );
    this.slider.mount();
  }
  
  setPage() {
    this.dom.current.textContent = this.rate * this.total;
    this.dom.total.textContent = `/ ${this.total}`;
  }

  destroy() {
    if (this.slider) this.slider.destroy();
  }
}

export default NeighborhoodSlides